import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Driver, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[]
}

export class DriverAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Driver> => {
    const response = await this.api.get(`/shipping/drivers/${guid}`, config)
    return rawTransform(Driver)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Driver>> => {
    const response = await this.api.get('/shipping/drivers', config)
    return paginatedTransform(Driver)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Driver> => {
    const response = await this.api.post('/shipping/drivers', data, config)
    return rawTransform(Driver)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Driver> => {
    const response = await this.api.patch(`/shipping/drivers/${guid}`, data, config)
    return rawTransform(Driver)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: 'shipping/drivers/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, 'drivers.csv')
  }

  uploadProfileImage = async (
    guid: string,
    file: File,
    config?: CustomAxiosConfig
  ): Promise<null> => {
    const form = new FormData()
    form.append('file', file)
    const axiosConfig = {
      ...config,
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    await this.api.put(`/shipping/drivers/${guid}/profile-image-upload`, form, axiosConfig)
    return null
  }

  uploadFront = async (
    guid: string,
    file: File,
    config?: CustomAxiosConfig
  ): Promise<null> => {
    const form = new FormData()
    form.append('file', file)
    const axiosConfig = {
      ...config,
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    await this.api.put(`/shipping/drivers/${guid}/front-upload`, form, axiosConfig)
    return null
  }

  uploadBack = async (
    guid: string,
    file: File,
    config?: CustomAxiosConfig
  ): Promise<null> => {
    const form = new FormData()
    form.append('file', file)
    const axiosConfig = {
      ...config,
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    await this.api.put(`/shipping/drivers/${guid}/back-upload`, form, axiosConfig)
    return null
  }
}
